frappe.provide("jhaudio.checkout");

const currencyFmt = new Intl.NumberFormat("en-US");

/**
 * Cart shipping address component page
 * @class CartShippingAddressWidget
 * @namespace jhaudio.checkout
 */
jhaudio.checkout.CartShippingAddressWidget = class extends jhaudio.checkout.CartAddressWidgetBase {
  /**
   * Instantiates a CartShippingAddressWidget the component
   * @param {*} $target The component container
   * @param {*} $ratesContainer The rates pane container
   * @param {*} $container The page container
   * @param {*} doc An object representing the quotation
   */
  constructor($target, $ratesContainer, $container, doc) {
    super($target, $container, doc);
    if ( !$ratesContainer || $ratesContainer.length == 0 ) {
      throw new Error("Invalid rates container");
    }
    this.$ratesContainer = $ratesContainer;
    this.$rates = this.$ratesContainer.find('.rates');
    this.$addressWidgetContainer = $target.closest('.address-widget-container');
    this.$pickupCheckbox = this.$ratesContainer.find('#shipping-pickup');
    this.$useMyShippingCheckbox = this.$ratesContainer.find('#use-my-shipping-account');
    this.init();
  }

  handlePickupToggle() {
    if ( this.$pickupCheckbox.is(':checked') ) {
      this.handleRateChange("PICK_UP");
      this.$ratesContainer.find('.shipping_options_divider').addClass("hidden");
      this.$ratesContainer.find('.use_my_shipping_account').addClass("hidden");
      this.$rates.addClass("hidden");
    } else {
      this.handleRateChange("");
      this.$ratesContainer.find('.shipping_options_divider').removeClass("hidden");
      this.$ratesContainer.find('.use_my_shipping_account').removeClass("hidden");
      this.$rates.removeClass("hidden");
    }
    if (this.$useMyShippingCheckbox && this.$useMyShippingCheckbox[0]) this.$useMyShippingCheckbox[0].checked = false;
  }

  /**
   * Initializes the component and binds
   */
  async init() {
    this.update(true);
    super.init();
    const me = this;

    const handleRateChange = function() {
      const rate = me.$ratesContainer.find('input[name=shipping_method]:radio:checked').val();
      me.handleRateChange(rate);
    }
    const handlePickupToggle = function() {
      me.handlePickupToggle();
    }

    const handleUseMyShipping = function() {
      me.handleUseMyShipping()
    }

    this.$ratesContainer.on('change', 'input[name=shipping_method]:radio', handleRateChange);
    this.$ratesContainer.on('change', '#shipping-pickup', handlePickupToggle);
    this.$ratesContainer.on('change', '#use-my-shipping-account', handleUseMyShipping);

    if ( this.doc.fedex_shipping_method == "PICK_UP" ) {
      this.$ratesContainer.find('#shipping-pickup').prop('checked', true);
      this.$ratesContainer.find('.shipping_options_divider').addClass("hidden");
      this.$rates.addClass("hidden");
      this.$addressWidgetContainer.find('.address-column').slideUp('fast');
      this.$addressWidgetContainer.find('.pickup-instructions').slideDown('fast');
    }

    if (this.doc.use_customer_fedex_account && this.$useMyShippingCheckbox && this.$useMyShippingCheckbox[0] && this.doc.fedex_shipping_method != "PICK_UP") {
      if (this.$useMyShippingCheckbox && this.$useMyShippingCheckbox[0]) this.$useMyShippingCheckbox[0].checked = true;
      me.handleUseMyShipping();
    }

    if (this.doc.fedex_shipping_method != "PICK_UP" && this.doc.use_customer_fedex_account) {
      if (this.$useMyShippingCheckbox && this.$useMyShippingCheckbox[0]) this.$useMyShippingCheckbox[0].checked = true;
      if (this.$pickupCheckbox && this.$pickupCheckbox[0]) this.$pickupCheckbox[0].checked = false;
      me.handleUseMyShipping();
    }
    if (this.doc.fedex_shipping_method == "PICK_UP") {
      if (this.$pickupCheckbox && this.$pickupCheckbox[0]) this.$pickupCheckbox[0].checked = true;
      if (this.$useMyShippingCheckbox && this.$useMyShippingCheckbox[0]) this.$useMyShippingCheckbox[0].checked = false;
      me.handlePickupToggle();
    }

    this.validate();
    this.update(false);
  }


  /**
   * Handles address selected event
   * @param {*} address_name
   */
  async onAddressSelected(address_name, is_po_box) {
    if ( !address_name ) {
      console.warn("Missing address name!");
    }

    await this.update(true);
    try {

      // Test for PO Box Addresses
      if (is_po_box) {
        this.$rates.empty();
        this.$rates.append('<li class="error text-center">We are Sorry!<br/>Currently we can not ship to PO Boxes.<br/>Please use another address.</li>');
        await this.update(false);
        return;
      }

      let response = undefined;
      this.$rates.empty();
      this.$rates.append(`<li class="rates-spinner text-center">Fetching Rates...</li>`);

      if ( !this.initializing ) {
        this.doc.shipping_address_name = address_name;
        this.doc.fedex_shipping_method = '';
      }

      try {
        response = await frappe.call({
          method: "shipment_management.shipengine.api.get_rates",
          args: {
            doc: this.doc,
            address: address_name,
            estimate: true
          },
          freeze: true
        });
      } catch(err) {
        if ( err.responseJSON ) {
          if ( err.responseJSON.exc ) {
            const exception = JSON.parse(err.responseJSON.exc);
            console.log(exception);
          }
        }
        this.$rates.empty();
        this.$rates.append('<li class="error text-center">Invalid shipping address!</li>');
        await this.update(false);
        return;
      }

      if ( response && response.message ) {
        this.$rates.empty();
        for(let rate of response.message ) {
          const fee = currencyFmt.format(rate.fee);
          const $rate = $(frappe.render_template("jha-cart-rates-item", {
            label: this.doc.use_customer_fedex_account ? `${rate.label}` : `${rate.label} +$${fee}`,
            value: rate.name,
            id: rate.name
          }))
          this.$rates.append($rate);
          if ( rate.name == this.doc.fedex_shipping_method ) {
            $rate.find('input').attr('checked', '');
          }
        }
      }

      const rate = this.$ratesContainer.find('input[name=shipping_method]:radio:checked').val();
      if ( rate ) {
        this.validate();
      }
    } finally {
      await this.update(false);
    }
  }
  /**
   * Handles address save event
   * @param {*} address
   */
  async onAddressSave(address) {
    super.onAddressSave(address);
    await this.update(true);

    if ( address.name ) {
      try {
        const r = await frappe.call({
          method: 'jhaudio.cart.update_order_shipping_address',
          args: {
            doctype: this.doc.doctype,
            docname: this.doc.name,
            address: address,
            update_rates: this.doc.shipping_address_name == address.name
          },
          freeze: true
        });
      } catch(err) {
        console.error(err);
        this.doc.fedex_shipping_method = '';
        await this.update(false);
        return;
      }
    } else {
      try {
        address.address_type = "Shipping";
        const new_address = await frappe.call('jhaudio.cart.save_order_address', { doc: address });
        const r = await frappe.call({
          method: "jhaudio.cart.set_order_shipping_address",
          args: {
            doctype: this.doc.doctype,
            docname: this.doc.name,
            address: new_address.message.name
          },
          freeze: true
        });
      } catch(err) {
        console.error(err);
        this.doc.fedex_shipping_method = '';
        await this.update(false);
        return;
      }
    }

    await this.update(false);
    window.location.reload();
}

  async handleRateChange(rate) {
    if ( rate == "PICK_UP" ) {
      this.$addressWidgetContainer.find('.address-column').slideUp('fast');
      this.$addressWidgetContainer.find('.pickup-instructions').slideDown('fast');
    } else {
      this.$addressWidgetContainer.find('.address-column').slideDown('fast');
      this.$addressWidgetContainer.find('.pickup-instructions').slideUp('fast');
    }

    this.doc.fedex_shipping_method = rate;
    await this.update(false);
  }

  async handleUseMyShipping() {
    this.doc.use_customer_fedex_account = this.$useMyShippingCheckbox.is(':checked') ? 1 : 0;
    let selected_address = $.find(".address-item[data-active]") && $.find(".address-item[data-active]")[0];

    if (this.$useMyShippingCheckbox.is(':checked')) {
      this.handleRateChange(this.doc.fedex_shipping_method);
    }

    if (this.$pickupCheckbox && this.$pickupCheckbox[0]) this.$pickupCheckbox[0].checked = false;

    await this.onAddressSelected($(selected_address).attr('data-address-name'));
    await this.update(false);
  }

  async onValidate() {
    const is_pickup = this.doc.fedex_shipping_method == "PICK_UP";
    const has_address_and_rate = this.doc.shipping_address_name && this.doc.fedex_shipping_method;
    const use_my_shipping = this.$useMyShippingCheckbox.is(':checked') && this.doc.fedex_shipping_method ? 1 : 0;
    const valid = (is_pickup || has_address_and_rate || use_my_shipping) && ! this.updating;

    if ( valid ) {
      this.$target.trigger('valid');
    } else {
      this.$target.trigger('invalid');
    }

    this.$target.trigger('updating', !!this.updating);
  }
}
